<script>
import { mapActions, mapGetters } from "vuex";
import { BaseButton, BaseIcon } from "@/components";
import PackageSettignsCreate from "./PackageSettignsCreate";

export default {
  name: "CardItem",
  components: {
    PackageSettignsCreate,
    BaseButton,
    BaseIcon,
  },
  props: {
    item: Object,
    currentTab: String,
    cssClass: String,
  },
  data() {
    return {
      packageDetail: null,
      marketInfo: null,
      platformInfo: null,
      isPopupVisible: false,
      loadDetail: false,
      isTerminal: true,
      algoDetail: {},
      isOperationWarning: false,
      isRuleMessageWarning: false,
      operationMessage: "",
      researchDetail: {},
      mutableItemRuleMessage: "",
      isUpgraded: false,
      isCancelled: false,
      selectBoxesStatus: null,
      triggerReRender: 0,
    };
  },
  computed: {
    ...mapGetters(["getMarketInfo"]),
  },
  methods: {
    ...mapActions([
      "getPlatform",
      "getMarket",
      "getAlgorithmDetail",
      "getResearchDetail",
      "getCheckForPurchaseUpgrade",
    ]),
    errorMessage(response) {
      return this.$toast.error(response.data.message);
    },
    addCart() {
      let cusId = null;
      if (this.$route.query.isRecommended === undefined) {
        cusId = this.$route.query.c;

        this.getCheckForPurchaseUpgrade({
          applicationId: this.item?.applicationId,
          platformId: this.item?.platform?.id,
        }).then((response) => {
          if (response.isUpgrade) {
            this.isUpgraded = true;
            if (
              response.purchaseDetail != null &&
              response.purchaseDetail?.packageStatus?.id != 8
            ) {
              this.isCancelled = false;
            } else if (
              response.purchaseDetail != null &&
              response.purchaseDetail?.packageStatus?.id == 8
            ) {
              this.isCancelled = true;
            }
          } else {
            this.isUpgraded = false;
            this.isCancelled = false;
          }

          this.loadDetail = true;
          this.triggerReRender++;

          this.handlePlatformInfo(cusId);
        });
      } else {
        this.handlePlatformInfo(cusId);
      }
    },
    handlePlatformInfo(cusId) {
      this.getPlatform([this.item.applicationId, cusId]).then((res) => {
        this.platformInfo = res.data.find((o) => o.id == this.item.id);

        if (this.item.ruleMessage != undefined) {
          this.mutableItemRuleMessage = this.item.ruleMessage[0];
          this.isRuleMessageWarning = true;
        }

        if (this.currentTab != "Algo" && this.currentTab != "Research") {
          this.handleMarketInfo(cusId);
        } else {
          if (this.currentTab == "Algo") {
            this.handleAlgorithmDetail(cusId);
          } else {
            this.handleResearchDetail();
          }
        }
      });
    },
    handleMarketInfo(cusId) {
      this.getMarket([
        this.item.applicationId,
        this.platformInfo?.platformId,
        cusId,
      ]).then((response) => {
        if (response?.data?.error === true) {
          this.errorMessage(response);
        } else {
          this.marketInfo = this.getMarketInfo;
          this.loadDetail = true;
          this.isPopupVisible = true;
        }
      });
    },
    handleAlgorithmDetail(cusId) {
      this.getAlgorithmDetail([this.item.id, cusId]).then((response) => {
        if (response?.data?.error === true) {
          this.errorMessage(response);
        } else {
          this.algoDetail = response.data;
          this.isTerminal = response.data?.isTerminal;
          this.isOperationWarning =
            response.data?.operationRule?.isOperationWarning;
          this.operationMessage =
            response.data?.operationRule?.operationMessage;
          this.loadDetail = true;
          this.isPopupVisible = true;
        }
      });
    },
    handleResearchDetail() {
      this.getResearchDetail([this.item.id]).then((response) => {
        if (response?.data?.error === true) {
          this.errorMessage(response);
        } else {
          this.researchDetail = response.data;
          this.loadDetail = true;
          this.isPopupVisible = true;
        }
      });
    },
    closePopup() {
      this.isPopupVisible = false;
    },
  },
};
</script>

<template>
  <div class="card-item-wrapper">
    <div class="card" :class="cssClass" @click="addCart()">
      <div class="card-image">
        <img
          class="img"
          v-if="item.imageUrl"
          alt="product image"
          :src="item.imageUrl"
        />
        <base-icon v-else name="no-image" class="img" />
      </div>
      <div class="card-text">
        <h6
          class="card-header"
          :class="{ noSub: !item.subtitle }"
          v-if="item.title"
        >
          {{ item.title }}
        </h6>
        <h6 class="name" v-if="item.subtitle">{{ item.subtitle }}</h6>
        <p class="description" v-if="item.description">
          {{ item.description }}
        </p>
      </div>
      <div class="add-btn">
        <base-button>Talep Et</base-button>
      </div>
    </div>
    <template v-if="item && this.getMarketInfo && loadDetail">
      <package-settigns-create
        v-if="isPopupVisible"
        :dataItem="item"
        :marketInfo="this.getMarketInfo"
        :platformInfo="platformInfo"
        :isPopupVisible="isPopupVisible"
        :currentTab="currentTab"
        :isTerminal="isTerminal"
        :algoDetail="algoDetail"
        :researchDetail="researchDetail"
        :operationMessage="operationMessage"
        :isOperationWarning="isOperationWarning"
        :isRuleMessageWarning="isRuleMessageWarning"
        :isUpgraded="isUpgraded"
        :isCancelled="isCancelled"
        :mutableItemRuleMessage="mutableItemRuleMessage"
        :startDates="selectBoxesStatus"
        :key="triggerReRender"
        @close="closePopup"
      />
    </template>
  </div>
</template>
<style lang="scss" scoped>
.card-container {
  .card-item-wrapper {
    max-width: 275px;
    @media (max-width: 768px) {
      max-width: 100%;
      min-width: auto;
      width: 100%;
    }
    @media (min-width: 820px) and (max-width: 899px) {
      .card {
        min-width: 225px !important;
      }
    }
  }
  &.bigger-package {
    .card-item-wrapper {
      min-width: 245px;
      .card {
        min-width: auto;
      }
    }
  }
  .card {
    border-radius: var(--radius-first);
    border: solid 1px var(--color-primary-tint-second);
    min-height: 288px;
    min-width: 275px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0 auto;

    @media (max-width: 768px) {
      min-height: 230px;
    }

    &:hover {
      box-shadow: 0px 0px 3px #d6d6d8;
      cursor: pointer;
    }

    &-image {
      margin-top: 20px;
      width: 100%;
      display: flex;
      place-content: center;
      .img {
        width: 80px;
      }
    }

    &-text {
      text-align: center;
    }
  }

  .card-header {
    padding-top: 10px;
    font-size: 14px;
    max-width: 75%;
    margin: 0 auto;
    font-weight: bold;
    line-height: 21px;
    margin-bottom: 5px;
    &.noSub {
      margin-top: -57px;
      @media (max-width: 768px) {
        margin-top: 0px;
      }
    }
  }
  .name {
    margin-bottom: 58px;
    color: var(--grayscale-120);
    font-size: 14px;
    font-weight: normal;
    padding: 0px 10px;
    @media (max-width: 768px) {
      margin-bottom: 10px;
    }
  }

  .description {
    color: var(--grayscale-50);
  }

  .add-btn {
    margin-bottom: 20px;
    text-align: center;
    padding: 0px 20px;

    button {
      width: 100%;
      background: var(--color-primary-active);
      height: 32px;
      font-weight: 400;
    }
  }
}
</style>
